import { useUnit } from 'effector-react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import { ErrorBoundary } from '@/components/ui/ErrorBoundary/ErrorBoundary'
import { $fanId } from '@/models/chattingUI/chats/chats.ts'
import { InfoTabs } from '@/modules/chatting/ui/chat-window/fan-info/info-tabs.tsx'
import { MessageSendingProgress } from '@/modules/chatting/ui/sidebar/MessageSendingProgress.tsx'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  open: boolean
  onClose?: () => void
}

export const FanInfo = ({ open, onClose }: Props) => {
  const fanId = useUnit($fanId)

  return (
    <div
      className={classNames(
        'bg-card bottom-0 right-0 top-0 z-[50] flex w-full max-w-[354px] shrink-0 flex-col border-l transition duration-300 ease-in-out max-md:absolute md:h-full',
        {
          hidden: !open,
        },
      )}
    >
      <ErrorBoundary
        fallbackTemplate="module"
        boundaryName="FanInfo"
        resetKeys={[fanId]}
      >
        <div className="bg-card absolute left-0 right-0 top-0 z-20 p-4 md:hidden">
          <CloseIcon
            onClick={onClose}
            className="hover:text-primary-500 h-5 w-5 cursor-pointer transition"
          />
        </div>
        <div className="px-4 pt-4">
          <MessageSendingProgress />
        </div>

        <div className="flex-1 space-y-4 overflow-auto px-4 pb-4 pt-[52px] md:pt-4">
          <InfoTabs />
        </div>
      </ErrorBoundary>
    </div>
  )
}
